import { reactive } from 'vue';

interface User {
  sub: string;
  name: string;
  given_name: string;
  family_name: string;
  picture: string;
  email: string;
  email_verified: boolean;
  locale: string;
}

interface AuthState {
  isAuthenticated: boolean;
  email: string | null;
  user: User | null;
}

interface AuthMethods {
  refresh(): Promise<void>;
  logout(): void;
}

export const authState: AuthState = reactive({
  isAuthenticated: false,
  user: null,
  email: null
});

export const authMethods: AuthMethods = {



  async refresh() {
    try {
      // Fetch user info from backend using cookies
      const baseUrl = import.meta.env.VITE_API_BASE_URL;
      const userResponse = await fetch(`${baseUrl}/manage/info`, {
        credentials: 'include', // Include cookies in the request
      });

      if (!userResponse.ok) {
        this.logout();
        return;
      }

      const userData: User = await userResponse.json();
      authState.email = userData.email;
      authState.isAuthenticated = true;
    } catch (error) {
      console.error('Failed to restore cookie-based authentication:', error);
      this.logout();
    }
  },

  logout() {
    authState.isAuthenticated = false;
    authState.email = null;
  }
};
